import { Component, Inject, OnInit, ViewChild, EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_228';

const stepsList = [
  { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Muebles Leasing', listHelp: ['564'] },
];
const tableStructure = [
  {id: 'sociedad', title: 'Sociedad'}, 
  {id: 'utilidad', title: 'Ingreso bruto'},
];

class ArticulosDominio {
  valor: number;
  nombre: string;
}

class Form1 {
id: number;
sociedad: string;
utilidad: string;
anioConstitucion: string;
valAporteSocial:string;
retencion:string;
}
@Component({
  selector: 'app-ingresos-utilidades-liquidacion-modal',
  templateUrl: './ingresos-utilidades-liquidacion-modal.component.html',
  styleUrls: ['./ingresos-utilidades-liquidacion-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresosUtilidadesLiquidacionModal extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;
  public listaAnioConstLiq = [];
  mensajeTabla = "Agregue, edite o elimine sus ingresos según su realidad económica.";

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;

  constructor(
    public dialogRef: MatDialogRef<IngresosUtilidadesLiquidacionModal>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento,
    private _componentFactory: ComponentFactoryService,
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
   // console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();

   /*  this.validateBtnRightActive();
    this.validateShowSave(); */
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.sociedad="";
    this.modelForm.utilidad="0";
    this.modelForm.valAporteSocial="0";
    this.modelForm.anioConstitucion="0"; 
    this.modelForm.retencion="0"; 
 //   this.reloadSelArticulos();
  }
  

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_565 == undefined){

      this.model.doc.cuerpo.cc_id_565 = []; 
      this.model.doc.cuerpo.cc_id_566 = []; 
      this.model.doc.cuerpo.cc_id_574 = [];
      this.model.doc.cuerpo.cc_id_569 = [];
      this.model.doc.cuerpo.cc_id_575 = [];
      this.model.doc.cuerpo.cs_id_568 = "0";
   
    }  
  }

  protected reloadSelArticulos(conservarArt?:boolean){//Dom 1649
    
  
  }

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_565.length; i++){
      this.modelForm.id=i;
      this.modelForm.sociedad=this.model.doc.cuerpo.cc_id_565[i].v;
      this.modelForm.utilidad=this.model.doc.cuerpo.cc_id_566[i].v;
      this.modelForm.anioConstitucion=this.model.doc.cuerpo.cc_id_574[i].v;
      this.modelForm.valAporteSocial=this.model.doc.cuerpo.cc_id_569[i].v; 
      this.modelForm.retencion=this.model.doc.cuerpo.cc_id_575[i].v; 
      
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }
  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_565[this.modelForm.id].v=this.modelForm.sociedad.toString();
    this.model.doc.cuerpo.cc_id_566[this.modelForm.id].v=this.modelForm.utilidad.toString();
    this.model.doc.cuerpo.cc_id_574[this.modelForm.id].v=this.modelForm.anioConstitucion.toString();
    this.model.doc.cuerpo.cc_id_569[this.modelForm.id].v=this.modelForm.valAporteSocial.toString();
    this.model.doc.cuerpo.cc_id_575[this.modelForm.id].v=this.modelForm.retencion.toString();

  }
  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_565.push({it: i, v:this.modelForm.sociedad});
    this.model.doc.cuerpo.cc_id_566.push({it: i, v:this.modelForm.utilidad.toString()});
    this.model.doc.cuerpo.cc_id_574.push({it: i, v:this.modelForm.anioConstitucion.toString()});
    this.model.doc.cuerpo.cc_id_569.push({it: i, v:this.modelForm.valAporteSocial.toString()});
    this.model.doc.cuerpo.cc_id_575.push({it: i, v:this.modelForm.retencion.toString()});
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_565.splice(index,1);
    this.model.doc.cuerpo.cc_id_566.splice(index,1);
    this.model.doc.cuerpo.cc_id_574.splice(index,1);
    this.model.doc.cuerpo.cc_id_569.splice(index,1);
    this.model.doc.cuerpo.cc_id_575.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_565.length;i++){
      this.model.doc.cuerpo.cc_id_565[i].it=i+1;
      this.model.doc.cuerpo.cc_id_566[i].it=i+1;
      this.model.doc.cuerpo.cc_id_574[i].it=i+1;
      this.model.doc.cuerpo.cc_id_569[i].it=i+1;
      this.model.doc.cuerpo.cc_id_575[i].it=i+1;

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.sociedad==undefined || this.modelForm.sociedad==null || this.modelForm.sociedad.trim()=="" ||
        this.modelForm.utilidad==undefined ||  this.modelForm.utilidad==null || 
        this.modelForm.anioConstitucion==undefined || this.modelForm.anioConstitucion==null || this.modelForm.anioConstitucion=="0" || 
        this.modelForm.valAporteSocial==undefined || this.modelForm.valAporteSocial==null ||
        this.modelForm.retencion==undefined || this.modelForm.retencion==null;  
  }

  public redondearFormData(){
    this.modelForm.utilidad=this.dutilidades.redondearValorMoneda(this.modelForm.utilidad.toString(),true);
    this.modelForm.retencion=this.dutilidades.redondearValorMoneda(this.modelForm.retencion.toString(),true);
    this.modelForm.valAporteSocial=this.dutilidades.redondearValorMoneda(this.modelForm.valAporteSocial.toString(),true);

  }

  public calcularValoresForm(conservarArt?:boolean){
  
  }


  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
        //this.editModeloDesdeForm();
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs568();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs568();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }
  operacionCs568(){
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].utilidad, suma);
    }
    this.model.doc.cuerpo.cs_id_568 = suma;

  }
 


  protected controlStep(direction: DirectionType): void {
   
  }



  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs568();
    this.dialogRef.close("");
  }

  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_565 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }

    this.operacionCs568();
    this.saveModel.emit(true);
    this.closeModal();

  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-utilidades-liquidacion-modal/ingresos-utilidades-liquidacion-modal.component.ts